export default __webpack_public_path__ + "static/media/936.1e7483f9.gif";